/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FinancingRefusedPaymentResource
 */
export interface FinancingRefusedPaymentResource extends ProjectDeliverablePaymentResource {
}

/**
 * Check if a given object implements the FinancingRefusedPaymentResource interface.
 */
export function instanceOfFinancingRefusedPaymentResource(value: object): value is FinancingRefusedPaymentResource {
    return true;
}

export function FinancingRefusedPaymentResourceFromJSON(json: any): FinancingRefusedPaymentResource {
    return FinancingRefusedPaymentResourceFromJSONTyped(json, false);
}

export function FinancingRefusedPaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingRefusedPaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function FinancingRefusedPaymentResourceToJSON(value?: FinancingRefusedPaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
    };
}

